<template>
  <div class="main-container" v-if="getUserType == 0">
    <div class="main-container__current-component">
      <ViewAll />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Landing-V2',
  components: {
    ViewAll: () => import('@/views/ViewAll'),
  },
  computed: {
    ...mapGetters('loginGeneral', ['getUser', 'getUserType', 'getTournaments']),
  },
};
</script>

<style scoped lang="scss">
.main-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &__current-component {
    width: 100%;
  }
}
</style>
